import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

function Prices() {
  const { theme } = useTheme();

  return (
    <div className="container mx-auto my-8 px-4">
      <h2
        className={`text-5xl md:text-6xl font-light mb-6 ${theme.text} font-handwriting`}
      >
        Kosten
      </h2>

      <div className="grid md:grid-cols-2 gap-8">
        <div className={`${theme.box} p-8 rounded-lg shadow-lg`}>
          <h3 className="text-2xl font-semibold mb-6 text-slate-800">
            Preise & Dauer
          </h3>
          <div className="space-y-4">
            <div className="flex justify-between items-center border-b border-slate-600 pb-2">
              <span className="text-lg">
                Unverbindliches Kennenlernen (30 Min.)
              </span>
              <span className="text-lg font-semibold">kostenlos</span>
            </div>
            <div className="flex justify-between items-center border-b border-slate-600 pb-2">
              <span className="text-lg">Einzelberatung (60-75 Min.)</span>
              <span className="text-lg font-semibold">90,00 €</span>
            </div>
            <div className="flex justify-between items-center border-b border-slate-600 pb-2">
              <span className="text-lg">Familienberatung (90 Min.)</span>
              <span className="text-lg font-semibold">120,00 €</span>
            </div>
            <div className="flex justify-between items-center border-b border-slate-600 pb-2">
              <span className="text-lg">
                Jugendliche & junge Erwachsene bis 23 Jahre (60 Min.)
              </span>
              <span className="text-lg font-semibold">75,00 €</span>
            </div>
          </div>
        </div>

        <div
          className={`bg-gradient-to-br ${theme.gradient} p-8 rounded-lg shadow-lg text-white`}
        >
          <h3 className="text-2xl font-bold mb-6">Wichtige Informationen</h3>
          <div className="space-y-4">
            <p className="text-lg leading-relaxed">
              Die Beratung ist in der Regel eine Selbstzahlerleistung. Die
              Kosten werden nicht von den gesetzlichen Krankenkassen übernommen.
            </p>

            <p className="text-lg leading-relaxed">
              Bei finanziellen Engpässen sprechen Sie mich gerne an - wir finden
              eine Lösung.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-12 bg-white p-8 rounded-lg shadow-lg">
        <h3 className="text-2xl font-semibold mb-6 text-slate-800">
          Terminvereinbarung & Absagen
        </h3>
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h4 className="text-xl font-semibold mb-3 text-slate-800">
              Terminvereinbarung
            </h4>
            <p className="text-lg text-slate-700 mb-4">
              Termine können Sie telefonisch oder per E-Mail vereinbaren. Ich
              bemühe mich um zeitnahe Termine, die sich gut in Ihren Alltag
              integrieren lassen.
            </p>
            <Link
              to="/contact"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              Zum Kontakt →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Prices;
